<template>
    <div class="row">
        <div class="col-md-12">
            <div class="form-group">
              <label v-if="sectionProductionDate" class="col-md-2 control-label">
                {{ trans('production_reports.production_list.production_date') }}
              </label>
              <label v-if="sectionDeliveryDate" class="col-md-2 control-label">
                {{ trans('production_reports.production_list.delivery_date') }}
              </label>
                <div class="col-md-1 pr-0">
                  <single-select
                      v-model="internalValue.productCategory"
                      :options="productCategories"
                      :allow-empty="false"
                      :disabled="disabled"
                      :placeholder="'purchase_order.material.product_categories' | trans"
                  />
                </div>
              <div v-if="showDeliveryDate" class="col-md-1 pr-0">
                    <date-picker
                          v-model="internalValue.deliveryDateFrom"
                          :time="false"
                          :init-value="false"
                          :disabled="disabled"
                          can-clear
                          :placeholder="'purchase_order.material.delivery_date_from' | trans"
                    />
                </div>
              <div v-if="showDeliveryDate" class="col-md-1 pr-0">
                    <date-picker
                        v-model="internalValue.deliveryDateTo"
                        :time="false"
                        :init-value="false"
                        :disabled="disabled"
                        can-clear
                        :placeholder="'purchase_order.material.delivery_date_to' | trans"
                    />
                </div>
              <div v-if="showProductionDate" class="col-md-1 pr-0">
                    <date-picker
                            v-model="internalValue.productionDateFrom"
                            :time="false"
                            :init-value="false"
                            :disabled="disabled"
                            can-clear
                            :placeholder="'purchase_order.material.production_date_from' | trans"
                    />
                </div>
              <div v-if="showProductionDate" class="col-md-1 pl-10 pr-0">
                    <date-picker
                            v-model="internalValue.productionDateTo"
                            :time="false"
                            :init-value="false"
                            :disabled="disabled"
                            can-clear
                            :placeholder="'purchase_order.material.production_date_to' | trans"
                    />
                </div>
                <div class="col-md-2 pl-10 pr-0">
                    <multi-select
                            v-model="internalValue.teams"
                            :checked="internalValue.teams"
                            :disabled="disabled"
                            :options="teams"
                            :placeholder="'purchase_order.material.teams' | trans"
                    />
                </div>
                <div class="col-md-2 pl-10 pr-0">
                    <multi-select
                            v-model="internalValue.brands"
                            :checked="internalValue.brands"
                            :disabled="disabled"
                            :options="brands"
                            :placeholder="'purchase_order.material.brands' | trans"
                    />
                </div>
                <div class="col-md-2 pl-10 production-row-buttons">
                    <i v-if="internalValue.isValid" class="fa fa-check-circle text-success font-lg"></i>
                    <i
                            v-else
                            class="fa fa-minus-circle text-danger font-lg"
                            :title="'offer.import.exceptions.invalid_date' | trans">
                    </i>
                    <button
                            v-if="canAdd"
                            class="btn btn-primary fa fa-plus"
                            :title="'grid.add_record' | trans"
                            :disabled="disabled"
                            @click="$emit('add')"
                    >
                    </button>
                    <button
                            v-if="canDelete"
                            class="btn btn-danger fa fa-trash"
                            :title="'grid.remove' | trans"
                            :disabled="disabled"
                            @click="$emit('delete')">
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DatePicker from '@component/datePicker.vue'
import MultiSelect from '@component/multiselect.vue'
import ProductionRow from '@js/forms/purchaseOrderMaterials/models/ProductionRow'
import SingleSelect from '@component/newsingleselect.vue'
import {
  PRODUCT_CATEGORIES_ALL,
  PRODUCT_CATEGORIES_BREAD,
  PRODUCT_CATEGORIES_FRESH,
  PRODUCT_CATEGORIES_OTHER
} from '@const/common'

export default {
  name: 'PurchaseOrderMaterialsProductionRow',
  components: {
    DatePicker,
    MultiSelect,
    SingleSelect,
  },
  props: {
    disabled: {
      type: Boolean,
      required: true,
    },
    value: {
      type: ProductionRow,
      required: true,
    },
    brands: {
      type: Array,
      required: true
    },
    teams: {
      type: Array,
      required: true
    },
    label: {
      type: String,
      required: true,
    },
    canDelete: {
      type: Boolean,
      required: true,
    },
    canAdd: {
      type: Boolean,
      required: true,
    },
    productCategories: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      showDeliveryDate: false,
      showProductionDate: false,
      sectionProductionDate: true,
      sectionDeliveryDate: false,
      internalValue: new ProductionRow(
        Object.values(this.value.brands),
        this.value.teams,
        this.value.productionDateFrom,
        this.value.productionDateTo,
        this.value.productCategory,
        this.value.deliveryDateFrom,
        this.value.deliveryDateTo,
        this.value.selectProductCategoryName
      ),
    }
  },
  watch: {
    'internalValue.productCategory': function (value) {
      const findProductCategories = this.productCategories.find(el => el.id === value)
      const selectProductCategories = findProductCategories ? findProductCategories.systemValue : null
      this.selectProductCategoryName = selectProductCategories

      if (selectProductCategories === PRODUCT_CATEGORIES_FRESH || selectProductCategories === PRODUCT_CATEGORIES_BREAD) {
        this.showProductionDate = false
        this.showDeliveryDate = true

        this.sectionProductionDate = false
        this.sectionDeliveryDate = true

        this.internalValue.productionDateFrom = null
        this.internalValue.productionDateTo = null
      } else if (selectProductCategories === PRODUCT_CATEGORIES_OTHER || selectProductCategories === PRODUCT_CATEGORIES_ALL) {
        this.showProductionDate = true
        this.showDeliveryDate = false

        this.sectionProductionDate = true
        this.sectionDeliveryDate = false

        this.internalValue.deliveryDateFrom = null
        this.internalValue.deliveryDateTo = null
      } else {
        this.showProductionDate = false
        this.showDeliveryDate = false

        this.internalValue.productionDateFrom = null
        this.internalValue.productionDateTo = null
        this.internalValue.deliveryDateFrom = null
        this.internalValue.deliveryDateTo = null
      }
    },
    internalValue: {
      handler(value) {
        this.$emit('input', new ProductionRow(
          Object.values(value.brands),
          value.teams,
          value.productionDateFrom,
          value.productionDateTo,
          value.productCategory,
          value.deliveryDateFrom,
          value.deliveryDateTo,
          this.selectProductCategoryName
        ))
      },
      deep: true
    },
  },
}
</script>

<style scoped>
.pl-10 {
    padding-left: 10px;
}

.pr-0 {
    padding-right: 0;
}

.production-row-buttons .btn {
    margin-left: 5px;
}

.production-row-buttons i {
    vertical-align: middle;
    padding-right: 10px;
}
</style>
